export default __webpack_public_path__ + "static/media/ISMO CLASS-7 EXAM PATTERN 2025.ebfd35b6.pdf";